import { UserAuth, UserContextType } from "app/context/AuthContext";
import { Path } from "app/path";
import {
  completeUserInvite,
  validateUserInviteToken,
} from "app/redux/userSlice";
import { getFormValues } from "app/utils/getFormValues";
import { useQuery } from "app/utils/useQuery";
import * as React from "react";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

export const useAcceptInvite = () => {
  const dispatch = useDispatch();

  const query = useQuery();
  const invitationToken = query.get("token");
  const navigate = useNavigate();
  const [isTokenValid, setIsTokenValid] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [user, setUser] = useState<any>();
  const { setUser:setLoggedInUser,signup } = UserAuth() as UserContextType;

  const { emailPassSignUp } = UserAuth() as UserContextType;

  const onSubmit = async (e: any) => {
    e.preventDefault();
    const { email, name, role, password, passwordConfirmation } = getFormValues(
      e.target
    );

    if (password.length < 8) {
      return toast.error("Password must be at least 8 characters long");
    }
    if (password !== passwordConfirmation) {
      return toast.error("Passwords do not match");
    }

    try {
      // await emailPassSignUp(email, password);
     // const user= await dispatch(completeUserInvite({email,password,name,token}) as any).unwrap();

      // console.log('data',user)

       await signup({email,password,name,invitationToken})
      // setLoggedInUser(user)
      // navigate(Path.HOME);
      // toast.success("Sign up successful, Welcome to the team!");
    } catch (error:any) {

      let message = "Something went wrong. Please try again.";

      if (error?.code === "auth/email-already-in-use") {
        message = "This email is already registered. Try logging in instead.";
      }

      toast.error(message);
      console.error(error);
    }
  };

  const validateToken = async () => {
    setIsLoading(true);
    try {
      const user = await dispatch(
        validateUserInviteToken({ token:invitationToken }) as any
      ).unwrap();
      if (!user.invitePending) {
        setIsLoading(false);
        // toast.error("Token is no longer valid, please contact the sender.");
        return;
      }
      setUser(user);
      setIsTokenValid(true);
      setIsLoading(false);
      toast.success("Invite is valid, please continue to sign up.");
    } catch (error:any) {
      setIsTokenValid(false);
      setIsLoading(false);
      toast.error(
        error.data.error??"Invalid token, please contact the sender for a new invite link."
      );
      console.log(error);
    }
  };

  useEffect(() => {
    if (!invitationToken) {
      setIsLoading(false);
      setIsTokenValid(false);
    }
    validateToken();
  }, [invitationToken]);

  return {
    isTokenValid,
    isLoading,
    user,
    onSubmit,
  };
};
